import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['textarea', 'counter'];
  static values = { maxLength: Number };

  connect() {
    this.updateCounter();
  }

  input() {
    this.updateCounter();
  }

  updateCounter() {
    const currentLength = this.textareaTarget.value.length;
    const remaining = this.maxLengthValue - currentLength;

    this.counterTarget.textContent = remaining;

    if (remaining < 20) {
      this.counterTarget.className = 'font-medium text-red-600';
    } else if (remaining < 50) {
      this.counterTarget.className = 'font-medium text-yellow-600';
    } else {
      this.counterTarget.className = 'font-medium text-gray-600';
    }
  }
}
